import { render, staticRenderFns } from "./TeknikDestek.vue?vue&type=template&id=e755f466&scoped=true&"
import script from "./TeknikDestek.vue?vue&type=script&lang=js&"
export * from "./TeknikDestek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e755f466",
  null
  
)

export default component.exports